module.exports = __webpack_public_path__ + "static/img/m_global_flow_step7@3x.ee91de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step7@3x.png
// module id = B8pm
// module chunks = 1